export class PageResponse {
  content?: Array<any>;
  totalElements?: number;
}
